import palette from 'theme/palette';

export default {
  root: {
    // datapicker
    '& .MuiPickersToolbarText-toolbarTxt': {
      color: palette.darkGray,
      opacity: 0.6,
    },
    '& .MuiPickersToolbarText-toolbarBtnSelected': {
      color: palette.darkGray,
      opacity: 1,
    },
    '& .MuiPickersDay-daySelected': {
      color: palette.white,
      backgroundColor: palette.darkGray,
    },
    '& .MuiPickersClockNumber-clockNumberSelected': {
      color: palette.darkGray,
    },
    '& .MuiPickersToolbar-toolbar': { backgroundColor: palette.greyCardBorder },
    '& .MuiPickerDTTabs-tabs': { backgroundColor: palette.greyCardBorder },
    '& .PrivateTabIndicator': { backgroundColor: palette.darkGray },
    '& .MuiButton-textPrimary': { color: palette.darkGray },
    '& .MuiPickersClock-pin': { backgroundColor: palette.greyCardBorder },
    '& .MuiPickersClockPointer-pointer': {
      backgroundColor: palette.sideGray,
    },
    '& .MuiPickersClockPointer-thumb': {
      border: `14px solid ${palette.sideGray}`,
    },
    '& .MuiPickersClockPointer-noPoint': { backgroundColor: palette.white },
  },
  elevation1: {
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
  },
};
